export default __webpack_public_path__ + "static/media/waitingForConfirmation.e7a59bdc.svg";